import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-our-story',
  templateUrl: './our-story.component.html',
  styleUrls: ['./our-story.component.css']
})
export class OurStoryComponent {

  mobileMenuOpen = false;

  constructor() {}

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
  }

  
  // Component Lifecycle
  ngOnInit(): void {
    this.checkReveal();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {

    if (event.target.innerWidth > 991) {
      this.mobileMenuOpen = false;
    }

  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.mobileMenuOpen = false;
  }
  
  
  // Scroll Animations
  @HostListener('window:scroll')
  onScroll(): void {
    this.checkReveal();
  }

checkReveal(): void {

  const elements = document.querySelectorAll(
    '.reveal, ' +
    '.reveal-left, ' +
    '.reveal-right, ' +
    '.reveal-up, ' +
    '.reveal-down, ' +
    '.reveal-fade, ' +
    '.reveal-scale-up, ' +
    '.reveal-scale-down, ' +
    '.reveal-bottom-blur, ' +
    '.reveal-top-blur, ' +
    '.reveal-swing, ' +
    '.reveal-pop, ' +
    '.reveal-flip-up, ' +
    '.reveal-flip-side, ' +
    '.reveal-curtain-up, ' +
    '.reveal-curtain-left, ' +
    '.reveal-diagonal, ' +
    '.reveal-float, ' +
    '.reveal-elastic, ' +
    '.reveal-focus, ' +
    '.reveal-tracking, ' +
    '.reveal-zoom, ' +
    '.reveal-zoom-out, ' +
    '.reveal-rotate, ' +
    '.reveal-slide'
  );

  const windowHeight = window.innerHeight;

  elements.forEach((el: any) => {

    const position = el.getBoundingClientRect().top;

    if (position < windowHeight - 100) {
      el.classList.add('active');
    }

  });

}
}